import React, { useState, useContext, useEffect } from 'react';
import { OnTheMenuDataContext } from '../../../context-api/OnTheMenuDataProvider';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import { getUrlParams } from '../../../global/getUrl';
import TextTransformation from '../../../global/textTransformation';
import MenuTabs from '../../../atomic/MenuTabs/MenuTabs';
import Storetitle from '../../../composed/storetitle/storetitle';
import './RestaurantMenu.scss';
import { LoginDataContext } from '../../../context-api/LoginDataProvider';
import AtomicButton from '../../../atomic/button/AtomicButton';
import { MealOfferingCalculation } from './../../../global/calculations';
import ProductCard from '../../../composed/ProductCard/ProductCard';
import ProductVerticalStepper from './VerticalProductSteppers';

const RestaurantMenuDesktop = () => {
  const { storename: urlStoreName } = getUrlParams();
  const [menuTabNames, setMenuTabNames] = useState({ Menu: [], 'Combo Menu': [] });
  const [activeTab, setActiveTab] = useState('');
  const [open, setOpen] = useState(true);
  const {
    productsData = {},
    sortedKitchenData,
    cartItems,
    getMealOffering,
  } = useContext(OnTheMenuDataContext);
  const { isLoggedIn, customerInfoData } = useContext(LoginDataContext);
  const { loading, data, success, errorMessage } = customerInfoData;
  const custInfoData = data?.data || [];

  const {
    regularMenuAvailable,
    subscriptionMenuAvailable,
    freeSubscriptionDelivery,
    deliverySubscription_fee,
    deliveryPayAsYouGo_fee,
  } = sortedKitchenData;
  const IsCartItems = Array.isArray(cartItems) && cartItems.length > 0;
  const [mealType, setMealType] = useState('Menu');

  const mealTypeButtons = [];
  if (regularMenuAvailable) {
    mealTypeButtons.push({ label: 'Regular Menu', value: 'Menu' });
  }
  if (subscriptionMenuAvailable) {
    mealTypeButtons.push({ label: 'Combo Menu', value: 'Combo Menu' });
  }

  const Mapping = { Menu: 'NonMealItems', 'Combo Menu': 'MealItems' };
  const ProductListObject =
    productsData?.data?.categorizedProducts?.[urlStoreName]?.[Mapping[mealType]];
  const checkMealMenu = mealType === 'Combo Menu';
  const handleMealType = (x) => {
    setMealType(x.value);
    setActiveTab(menuTabNames[x.value]?.[0] || '');
    scrollToTop();
  };

  const custActStatus =
    custInfoData?.user_Info?.reason_status === 'Active' ||
    custInfoData?.user_Info?.reason_status === 'Customer unsubscribed';
  const custMealPlan = custInfoData?.meal_Package?.meal_plan;
  const custActType = custInfoData?.user_Info?.account_type === 'Subscription';

  const custErrorUser = errorMessage === 'User does not exist'; // Logot User and ask to login again
  const custAdminInactive = errorMessage === 'Account is blocked by Administration';
  const zeroPlates = (custInfoData?.subscription_detail?.total_plates_tobe_serve || 0) === 0; // Chck with kuldeep
  const zeroPlatesAvailable = custInfoData?.available_plates === 0;
  const disableProductView = !isLoggedIn || !custActType || zeroPlatesAvailable;

  useEffect(() => {
    if (productsData.data && urlStoreName) {
      if (
        productsData?.data?.categorizedProducts &&
        productsData?.data?.categorizedProducts?.[urlStoreName]
      ) {
        setMenuTabNames({
          ...menuTabNames,
          Menu:
            Object.keys(
              productsData?.data?.categorizedProducts?.[urlStoreName]?.NonMealItems || {}
            ) || [],
          'Combo Menu':
            Object.keys(
              productsData?.data?.categorizedProducts?.[urlStoreName]?.MealItems || {}
            ).filter((key) => {
              const allowedProducts = getMealOffering()[key];
              if (!allowedProducts) {
                return false;
              }
              return true;
            }) || [],
        });

        setActiveTab(
          (Object.keys(
            productsData?.data?.categorizedProducts?.[urlStoreName]?.NonMealItems || {}
          ) || [])[0] || ''
        );
      }
    }
  }, [productsData]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div>
      <Storetitle mealType={mealType} />
      {/* <StoreAvertisment /> */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          position: 'sticky',
          top: '62px',
          // width: '98%',
          maxWidth: '1480px',
          backgroundColor: 'white',
          zIndex: '1',
          boxShadow: '0 3px 3px -1px rgba(0,0,0,.2)',
          marginBottom: '10px',
        }}
      >
        <div>
          {mealTypeButtons.map((el, index) => {
            return (
              <button
                key={`${el.menu}_${index}`}
                className={`button meal-type-button ${
                  mealType === el.value ? 'active-button-desktop' : 'inactive-button-desktop'
                }`}
                onClick={() => {
                  handleMealType(el);
                }}
              >
                <div className='meal-type-button-content'>
                  <div className='meal-type-button-label'>{el.label}</div>
                  {(deliveryPayAsYouGo_fee > 0 || deliverySubscription_fee > 0) && (
                    <div className='meal-type-button-subcontent'>
                      {el.value !== 'Combo Menu'
                        ? deliveryPayAsYouGo_fee > 0
                          ? `$${deliveryPayAsYouGo_fee} Delivery Fee | 20-40 min`
                          : null
                        : deliverySubscription_fee > 0 && freeSubscriptionDelivery
                        ? `$${deliverySubscription_fee} Delivery Now | Free NextDay`
                        : deliverySubscription_fee > 0
                        ? `$${deliverySubscription_fee} Delivery Now`
                        : ''}
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
        {/* {checkMealMenu && <div style={{
                    fontFamily: 'roboto',
                    fontWeight: '400',
                    fontSize: '12px',
                    margin: '10px',
                    border: '1px solid #FF6038',
                    borderRadius: '3px',
                    backgroundColor: '#ffe1d5',
                    padding: '3px '
                }}> {'You can use this area for some sort of alert to user'}</div>} */}
      </div>
      <div className='inner-container-desktop'>
        <div className='inner-tabs-section-1'>
          <div style={{ position: 'sticky', top: '0%' }}>
            <div
              style={{
                color: '#181436',
                fontFamily: 'Roboto Bold',
                letterSpacing: '0.5px',
                fontSize: '16px',
                margin: '10px',
                paddingLeft: '5px',
              }}
            >
              {' '}
              Categories
            </div>
            {menuTabNames[mealType]?.length > 0 && (
              <MenuTabs
                tabNames={menuTabNames[mealType]}
                value={activeTab}
                setValue={setActiveTab}
              />
            )}
          </div>
        </div>

        <div className='inner-product-section-2'>
          <div className='product-container'>
            {/*{mealType === 'Combo Menu' && disableProductView && <div style={{
                            width: '98%',
                            height: '100%',
                            position: 'absolute',
                            // background: 'rgb(0,0,0,0.2)',
                            background: 'rgb(0, 0, 0 ,0.2)',
                            // opacity: '0.8',
                            border: '1px solid #181436',
                            borderRadius: '5px',
                            display: 'flex',
                            // justifyContent: 'center', 
                            // alignItems: 'top'
                            zIndex: 2,
                            top: 0
                        }}>
                            <div className='product-login-popup'>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <div>
                                        <InsertEmoticonIcon sx={{ color: '#181436', fontSize: '40px' }} />
                                    </div>
                                    <div style={{
                                        margin: '0px 0px 0px 10px',
                                        transform: 'translateZ(45px)',
                                        fontFamily: 'Roboto Medium', fontSize: '18px',
                                        color: '#FF7A28'
                                    }}>
                                        {ButtonSwitchSubscription()?.verbiage}
                                    </div>
                                </div>

                                <AtomicButton
                                    label={ButtonSwitchSubscription()?.buttonLabel}
                                    loading={false}
                                    style={{ height: '30px', width: '40%' }}
                                    handleSubmit={ButtonSwitchSubscription()?.handleMethod}
                                />
                            </div>
                           



                        </div>} */}

            {mealType === 'Menu' &&
              Object.keys(ProductListObject || {}).map((el) => {
                return (
                  <div className='product-card-list' id={el} key={el}>
                    <div
                      style={{
                        color: '#181436',
                        fontWeight: '600',
                        fontSize: '16px',
                        margin: '10px',
                        paddingLeft: '5px',
                        textTransform: 'capitalize',
                      }}
                    >
                      {TextTransformation(el)}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', zIndex: '0' }}>
                      {ProductListObject[el] &&
                        ProductListObject[el].map((product) => (
                          <div key={product.product_name}>
                            <ProductCard product={product} mealType={mealType}></ProductCard>
                          </div>
                        ))}
                    </div>
                  </div>
                );
              })}

            {mealType === 'Combo Menu' && (
              <ProductVerticalStepper ProductListObject={ProductListObject} mealType={mealType} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantMenuDesktop;
